import React from 'react';
import { results } from '../data/content';
import { Reveal } from './Reveal';
export function Results() {
  return <section aria-label="Resultados de Almaria" className="px-6 lg:px-10" data-id="element-117" data-mp="15f1nyeh5wzem">
      <div className="relative mx-auto max-w-7xl overflow-hidden rounded-4xl bg-ink px-8 py-16 lg:px-14 lg:py-20" data-id="element-118" data-mp="1jeasuhzx473a">
        <div aria-hidden="true" className="pointer-events-none absolute -left-24 -top-24 h-72 w-72 rounded-full bg-accent/25 blur-3xl" data-id="element-119" data-mp="1fb4pbi46wu0i" />
        <div aria-hidden="true" className="pointer-events-none absolute -bottom-32 right-0 h-80 w-80 rounded-full bg-accent/15 blur-3xl" data-id="element-120" data-mp="1ocvt2hf66qrq" />

        <Reveal data-id="element-121" data-mp="230yztt11e6hl">
          <p className="relative text-[13px] font-medium uppercase tracking-[0.16em] text-white/50" data-id="element-122" data-mp="233l67pc6yfy8">
            Resultados
          </p>
        </Reveal>

        <dl className="relative mt-10 grid gap-10 sm:grid-cols-2 lg:grid-cols-4" data-id="element-123" data-mp="2c38aqk07w1vi">
          {results.map((item, i) => <Reveal key={item.label} delay={i * 0.08} data-id="element-124" data-mp="2756qvwuyvyiz" data-mpi={i}>
              <div className="flex flex-col-reverse border-l border-white/15 pl-5" data-id="element-125" data-mp="1m3uhv8v75g54">
                <dt className="mt-3 text-sm font-medium text-white/60" data-id="element-126" data-mp="1r1vyln55h3df">{item.label}</dt>
                <dd className="text-5xl font-semibold tracking-[-0.04em] text-white lg:text-6xl" data-id="element-127" data-mp="1w18n0cbo6ii4">
                  {item.value}
                </dd>
              </div>
            </Reveal>)}
        </dl>
      </div>
    </section>;
}